<template>
  <span class="basket-quantity">
    <template v-if="loaded">
      <basket-item-quantity v-model="count"></basket-item-quantity>
    </template>
    <template v-else>
      <loading-spinner></loading-spinner>
    </template>

    {{ noun }}
  </span>
</template>

<script>
import { BasketItemQuantity } from "spiritweb.packages.ecommerce";
import LoadingSpinner from "~/Components/LoadingSpinner.vue";

export default {
  name: "BasketQuantity",
  components: {
    BasketItemQuantity,
    LoadingSpinner
  },
  data: () => ( {
    loaded: true,
    count: 0
  } ),
  computed: {
    noun () {
      let result = "items";

      if ( this.count === 1 ) {
        result = "item";
      }

      return result;
    }
  }
};
</script>

<style lang="less" scoped>
.loading-spinner {
  color: #fff;
  display: inline-block;
  margin-right: 5px;

  /deep/ svg {
    font-size: 1rem;
  }
}
</style>
